import { useMaintenance } from '../context/MaintenanceContext';

const MaintenanceBanner = () => {
  const { isMaintenanceMode } = useMaintenance();

  if (!isMaintenanceMode) {
    return null;
  }

  return (
    <div className="maintenance-banner">
      <p>
        Due to scheduled maintenance, media features like adding, editing, and deleting items are temporarily disabled.
        They should be back in about an hour. Thanks for your patience!
      </p>
    </div>
  );
};

export default MaintenanceBanner;

